import findClassToken from '../../../breakpoint-editing/helpers/find-class-token';
import removeClassTokens from '../../../breakpoint-editing/helpers/remove-class-tokens';
import upsertClassToken from '../../../breakpoint-editing/helpers/upsert-class-token';
import { targetClassesConfig } from '../../constants/target-classes';
import breakpoints, { breakpointPrefixByKey } from '../../constants/breakpoints';

const tokensOf = (target) => targetClassesConfig[target]?.tokens || {};

const serialize = (target, value) => tokensOf(target)[value];

const parse = (target, body) => {
  const tokens = tokensOf(target);

  return Object.keys(tokens).find((value) => tokens[value] === body) || null;
};

const matches = (target, body) => parse(target, body) !== null;

const readValues = ({ element, target }) => {
  const classAttribute = element?.getAttribute('class') || '';

  return breakpoints.reduce((collectedValues, { key, prefix }) => {
    const token = findClassToken(classAttribute, {
      prefix,
      matchesToken: (body) => matches(target, body),
    });

    if (token === null) {
      return collectedValues;
    }

    const value = parse(target, token);

    if (value === null) {
      return collectedValues;
    }

    return { ...collectedValues, [key]: value };
  }, {});
};

const patch = ({ currentClass = '', target, value, breakpointKey }) => {
  const serialized = serialize(target, value);

  if (serialized === undefined) {
    return currentClass;
  }

  return upsertClassToken(currentClass, {
    prefix: breakpointPrefixByKey[breakpointKey],
    matchesToken: (body) => matches(target, body),
    token: serialized,
  });
};

const remove = ({ currentClass = '', target, breakpointKey }) =>
  removeClassTokens(currentClass, {
    prefix: breakpointPrefixByKey[breakpointKey],
    matchesToken: (body) => matches(target, body),
  });

export default {
  serialize,
  matches,
  parse,
  readValues,
  patch,
  remove,
};
